// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ScheduleButton__container-acf4e2 {
  margin-inline-start: 16px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatFooter/InputPanel/InputSection/ScheduleButton/styles.m.css"],"names":[],"mappings":"AAAA;EACE,yBAAA;AACF","sourcesContent":[".container {\n  margin-inline-start: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ScheduleButton__container-acf4e2`
};
module.exports = ___CSS_LOADER_EXPORT___;
